import dayjs from "dayjs";

/** Niveles alineados con el Gantt de CriticalPathHorizontal1. */
export const SEMAFORO_LEVELS = {
  GREEN: "green",
  RED: "red",
  ORANGE: "orange",
  GREY: "grey",
  NEUTRAL: "neutral",
};

export const SEMAFORO_PALETTE = {
  green: "#00c853",
  red: "#e53935",
  orange: "#ff9800",
  grey: "#9e9e9e",
  neutral: null,
};

const SEMAFORO_WEIGHT = {
  red: 4,
  orange: 3,
  grey: 2,
  neutral: 1,
  green: 0,
};

function parsePhaseDate(value) {
  if (value == null || value === "") return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.startOf("day") : null;
}

/**
 * Calcula semáforo operativo de una fase CP.
 * Usa Updated si existe; si no, Expected. Real = fase cumplida (verde).
 */
export function computePhaseSemaforo({
  expected = null,
  updated = null,
  real = null,
  now = dayjs(),
} = {}) {
  const realDate = parsePhaseDate(real);
  if (realDate) {
    return { level: SEMAFORO_LEVELS.GREEN, label: "done" };
  }

  const planDate = parsePhaseDate(updated) || parsePhaseDate(expected);
  if (!planDate) {
    return { level: SEMAFORO_LEVELS.NEUTRAL, label: "none" };
  }

  const today = now.startOf("day");
  const diffDays = planDate.diff(today, "day");

  if (diffDays < 0) {
    return { level: SEMAFORO_LEVELS.GREY, label: "overdue" };
  }
  if (diffDays <= 5) {
    return { level: SEMAFORO_LEVELS.RED, label: "urgent" };
  }
  if (diffDays <= 10) {
    return { level: SEMAFORO_LEVELS.ORANGE, label: "attention" };
  }
  return { level: SEMAFORO_LEVELS.GREEN, label: "ok" };
}

export function semaforoLevelWeight(level) {
  return SEMAFORO_WEIGHT[level] ?? 0;
}

/** Peor semáforo de un mapa de fases (para ordenar filas). */
export function scoreBlockSemaforo(fechas = {}) {
  let worst = 0;
  for (const phase of Object.values(fechas || {})) {
    const w = semaforoLevelWeight(phase?.semaforo);
    if (w > worst) worst = w;
  }
  return worst;
}

export function enrichFechaWithSemaforo(fechaEntry, timelineTask) {
  const sem = computePhaseSemaforo({
    expected: timelineTask?.ExpectedDate ?? fechaEntry?.expected,
    updated: timelineTask?.UpdatedDate ?? fechaEntry?.updated,
    real: timelineTask?.RealDate ?? fechaEntry?.real,
  });
  return {
    ...fechaEntry,
    expected: timelineTask?.ExpectedDate ?? fechaEntry?.expected ?? null,
    updated: timelineTask?.UpdatedDate ?? fechaEntry?.updated ?? null,
    real: timelineTask?.RealDate ?? fechaEntry?.real ?? null,
    semaforo: sem.level,
    semaforoLabel: sem.label,
  };
}

export function muiColorFromSemaforo(level, theme) {
  switch (level) {
    case SEMAFORO_LEVELS.GREEN:
      return theme.palette.success.main;
    case SEMAFORO_LEVELS.RED:
      return theme.palette.error.main;
    case SEMAFORO_LEVELS.ORANGE:
      return theme.palette.warning.main;
    case SEMAFORO_LEVELS.GREY:
      return theme.palette.text.disabled;
    default:
      return theme.palette.text.disabled;
  }
}
